import React from "react";

function SvgIcMapPoi110(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 32 32" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M11.5 13.192c-.878 0-1.591-.745-1.591-1.667 0-.92.713-1.666 1.591-1.666.879 0 1.591.746 1.591 1.666 0 .922-.712 1.667-1.591 1.667M24 23a2 2 0 012 2H6a2 2 0 012-2zm0-7v5h-2v-5h2zM11.541 7.938c1.926 0 3.364 1.455 3.454 3.573l.005.214v9.25H8v-9.25c0-2.234 1.551-3.787 3.541-3.787zm6.219-.466l.766 2.738-1.76.493L16 7.965l1.76-.493zm3.52-.985l.767 2.739-1.76.491-.767-2.738 1.76-.492zm3.905.384c.198.709-.036 1.404-.524 1.615l-.101.036-.752.21-.767-2.738.752-.21c.557-.155 1.18.331 1.392 1.087z"
          fill="#FFF"
        />
      </g>
    </svg>
  );
}

export default SvgIcMapPoi110;
